<template>
  <div class="mt-4 mr-2 pb-16">
    <div
      class="forum-create"
      @click="showPermissionPending"
    >
      Create New Post
    </div>
    <NewsForumContentPost
      v-for="post in posts"
      v-show="post.episode <= currentEpisode"
      :key="post.id"
      :post="post"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import posts from '@/services/forumContent'
import NewsForumContentPost from '@/components/News/NewsForumContentPost.vue'

export default {
  name: 'NewsForumContent',

  components: {
    NewsForumContentPost,
  },

  data() {
    return {
      posts,
      show: false,
    }
  },

  computed: {
    ...mapGetters({
      currentEpisode: 'auth/currentEpisode',
    }),
  },

  methods: {
    ...mapActions({
      showPermissionPending: 'auth/showPermissionPending',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.forum {
  &-create {
    font-family: 'proxima-nova';
    height: 41px;
    @apply cursor-pointer bg-blue-light-navy text-blue-light uppercase flex justify-center items-center;
  }
}
</style>
